<jhi-bary-options-selector
  [label]="switchCase('ACCESS_CONSTRAINT.PICKUP.LABEL' | translate, 'ACCESS_CONSTRAINT.DELIVERY.LABEL' | translate)"
  [titleKey]="switchCase('ACCESS_CONSTRAINT.PICKUP.TITLE', 'ACCESS_CONSTRAINT.DELIVERY.TITLE')"
  [control]="control"
  justifyContent="justify-content-start"
  [tooltip]="(transport?.isFTL() ? switchCase('ACCESS_CONSTRAINT.PICKUP.TOOLTIP', 'ACCESS_CONSTRAINT.DELIVERY.TOOLTIP') : '') | translate"
  [options]="accessConstraints"
></jhi-bary-options-selector>
